import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
} from '@mui/material';
import Title from '../../components/Title';
import { useAccount } from '../../context/AccountContext';
import * as AppUrls from '../../common/AppUrls';


const TITLE = 'Home';

export default function TransientDashboardHome() {
  const navigate = useNavigate();
  const { account } = useAccount();

  const isOrgSetupNeed =
    !!account?.organization?.id &&
    !account?.organization?.org_type;
  
  useEffect(() => {
    if (isOrgSetupNeed) {
      navigate(AppUrls.ACCOUNT_URL);
    }
  }, [isOrgSetupNeed, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 64px - 64px)', // viewport height - margings - app bar
      }}
    >
      {/* Title and Button (fixed) */}
      <Box
        sx={{
          flexShrink: 0, // Top level space distribution
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Title */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            mt: 1,
            mb: 1,
          }}
        >
          <Title>{TITLE}</Title>
        </Box>
      </Box>
    </Box>
  );
}
